import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import Home from './pages/Home';
import Products from './pages/Products';
import HealHub from './pages/HealHub';
import Suraksha from './pages/Suraksha';
import Vedant from './pages/Vedant';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import Careers from './pages/Careers';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import GrievanceOfficer from './pages/GrievanceOfficer';
import DPDPCompliance from './pages/DPDPCompliance';

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/healhub" element={<HealHub />} />
          <Route path="/suraksha" element={<Suraksha />} />
          <Route path="/vedant" element={<Vedant />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/grievance-officer" element={<GrievanceOfficer />} />
          <Route path="/dpdp-compliance" element={<DPDPCompliance />} />

          {/* Redirects */}
          <Route
  path="/hire-developers"
  element={<Navigate to="/services#augmentation" replace />}
/>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}